import {Injectable, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { createRequestOption } from '../common/utils/request-util';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(
    private http: HttpClient,
  ) {
  }
  getAllResource() {
    return this.http.get(environment.urlBackEnd + 'res/all',  {  observe: 'response' });
  }
  getAllLifeHero() {
    return this.http.get( environment.urlBackEnd + 'life-hero/resource/all');
  }
  loadSummaryConsultantRequest(){
    return this.http.get(environment.urlBackEnd + 'life-hero/org/consult-request/summary');
  }
  queryConsultantRequest(body) {
    return this.http.post(environment.urlBackEnd + 'life-hero/org/consult-request/list/', body);
  }
}
